import { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';

const maskCPF = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
};

const maskTelefone = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : '';
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

const maskCEP = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
};

const maskCartao = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 16);
  return d.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
};

const inputStyle = {
  width: '100%',
  padding: '11px 13px',
  border: '1.5px solid #e0e6f0',
  borderRadius: '10px',
  fontSize: '14px',
  background: '#f5f8ff',
  outline: 'none',
  color: '#222',
  boxSizing: 'border-box',
};

const labelStyle = {
  fontSize: '12px',
  fontWeight: '600',
  color: '#4a5568',
  marginBottom: '5px',
  display: 'block',
};

const sectionTitleStyle = {
  fontSize: '13px',
  fontWeight: '700',
  color: '#1e88e5',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  margin: '0 0 14px 0',
};

// Extrai mensagem legível da resposta de erro da API
const buildErrorMessage = (data) => {
  const errors = data?.errors;
  if (Array.isArray(errors) && errors.length > 0) {
    return errors.map(e => e.message).filter(Boolean).join(' | ') || data?.message || 'Erro ao processar pagamento.';
  }
  return data?.message || 'Erro ao processar pagamento.';
};

const Field = ({ label, children }) => (
  <div>
    <label style={labelStyle}>{label}</label>
    {children}
  </div>
);

const DROPDOWN_MAX_HEIGHT = 200;

const CustomSelect = ({ options, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [dropStyle, setDropStyle] = useState({});
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);
  const selected = options.find(o => o.value === value) || options[0];

  useEffect(() => {
    const handleOutside = (e) => {
      const insideTrigger = triggerRef.current?.contains(e.target);
      const insideDropdown = dropdownRef.current?.contains(e.target);
      if (!insideTrigger && !insideDropdown) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, []);

  const handleToggle = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const goUp = spaceBelow < DROPDOWN_MAX_HEIGHT + 8;
      setDropStyle({
        position: 'fixed',
        left: rect.left,
        width: rect.width,
        zIndex: 99999,
        ...(goUp
          ? { bottom: window.innerHeight - rect.top + 4 }
          : { top: rect.bottom + 4 }),
      });
    }
    setOpen(o => !o);
  };

  const dropdown = open ? (
    <div
      ref={dropdownRef}
      style={{
        ...dropStyle,
        background: '#fff',
        border: '1.5px solid #c5d5f0',
        borderRadius: '10px',
        maxHeight: `${DROPDOWN_MAX_HEIGHT}px`,
        overflowY: 'auto',
        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
      }}
    >
      {options.map(opt => (
        <div
          key={opt.value}
          onClick={() => { onChange(opt.value); setOpen(false); }}
          style={{
            padding: '11px 14px',
            fontSize: '14px',
            cursor: 'pointer',
            background: opt.value === value ? '#e8f0fe' : 'transparent',
            color: opt.value === value ? '#1565c0' : '#222',
            fontWeight: opt.value === value ? '600' : '400',
            borderBottom: '1px solid #f0f4ff',
          }}
        >
          {opt.label}
        </div>
      ))}
    </div>
  ) : null;

  return (
    <div ref={triggerRef} style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={handleToggle}
        style={{
          ...inputStyle,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <span>{selected?.label}</span>
        <span style={{ fontSize: '12px', marginLeft: '8px', color: '#666', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▼</span>
      </button>
      {ReactDOM.createPortal(dropdown, document.body)}
    </div>
  );
};

const btnPrimary = {
  flex: 1,
  padding: '15px',
  background: 'linear-gradient(135deg, #1e3a5f 0%, #1565c0 100%)',
  color: 'white',
  border: 'none',
  borderRadius: '12px',
  fontSize: '15px',
  fontWeight: '800',
  letterSpacing: '0.5px',
  cursor: 'pointer',
  textTransform: 'uppercase',
};

const btnSecondary = {
  padding: '15px 20px',
  background: '#f0f4f8',
  color: '#4a5568',
  border: 'none',
  borderRadius: '12px',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',
};

const ModalCheckoutPlano = ({ isOpen, onClose, plano, precos }) => {
  const history = useHistory();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [mesmosDAados, setMesmosDados] = useState(false);

  const [aluno, setAluno] = useState({ nome: '', cpf: '', email: '', senha: '', telefone: '' });
  const [portador, setPortador] = useState({ nome: '', email: '', cpf_cnpj: '', telefone: '', cep: '', numero: '' });
  const [cartao, setCartao] = useState({ numero: '', mes: '', ano: '', ccv: '', parcelas: '1' });

  const precoPlano = precos[plano?.toLowerCase()] || { preco: 0, quant_parcelas: 12 };
  const maxParcelas = precoPlano.quant_parcelas;
  const precoTotal = precoPlano.preco;

  const parcelasOptions = Array.from({ length: maxParcelas }, (_, i) => {
    const n = i + 1;
    const valor = (precoTotal / n).toFixed(2).replace('.', ',');
    return { value: String(n), label: `${n}x de R$ ${valor}` };
  });

  useEffect(() => {
    if (mesmosDAados) {
      setPortador(prev => ({
        ...prev,
        nome: aluno.nome,
        email: aluno.email,
        cpf_cnpj: aluno.cpf.replace(/\D/g, ''),
        telefone: aluno.telefone,
      }));
    }
  }, [mesmosDAados, aluno]);

  const resetForm = () => {
    setError('');
    setSuccess(false);
    setStep(1);
    setMesmosDados(false);
    setAluno({ nome: '', cpf: '', email: '', senha: '', telefone: '' });
    setPortador({ nome: '', email: '', cpf_cnpj: '', telefone: '', cep: '', numero: '' });
    setCartao({ numero: '', mes: '', ano: '', ccv: '', parcelas: '1' });
  };

  const handleClose = () => {
    if (!loading) { resetForm(); onClose(); }
  };

  const validateStep1 = () => {
    if (!aluno.nome.trim()) return 'Informe seu nome completo.';
    if (aluno.cpf.replace(/\D/g, '').length < 11) return 'CPF inválido — informe os 11 dígitos.';
    if (!aluno.email.includes('@')) return 'E-mail inválido.';
    if (!aluno.senha) return 'Informe uma senha.';
    if (aluno.telefone.replace(/\D/g, '').length < 10) return 'Telefone inválido.';
    return null;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (step === 1) {
      const err = validateStep1();
      if (err) { setError(err); return; }
      setError('');
      setStep(2);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const payload = {
        plano,
        usuario: {
          nome: aluno.nome,
          cpf: aluno.cpf.replace(/\D/g, ''),
          email: aluno.email,
          senha: aluno.senha,
          telefone: aluno.telefone,
        },
        cartao_credito: {
          portador: {
            nome: portador.nome,
            email: portador.email,
            cpf_cnpj: portador.cpf_cnpj.replace(/\D/g, ''),
            telefone: portador.telefone,
            endereco: {
              cep: portador.cep.replace(/\D/g, ''),
              numero: portador.numero,
            },
          },
          dados_cartao: {
            numero: cartao.numero.replace(/\D/g, ''),
            mes_expiracao: cartao.mes,
            ano_expiracao: cartao.ano,
            ccv: cartao.ccv,
            numero_parcelas: parseInt(cartao.parcelas, 10),
          },
        },
      };

      const response = await api.post('/pagamento/checkout', payload);

      if (response.data?.status === 'error') {
        setError(buildErrorMessage(response.data));
        return;
      }

      setSuccess(true);
    } catch (err) {
      const data = err.response?.data;
      if (err.response?.status === 409) {
        setError('E-mail ou CPF já cadastrado. Faça login para continuar.');
      } else if (data) {
        setError(buildErrorMessage(data));
      } else {
        setError('Erro ao processar pagamento. Verifique os dados e tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Modal show={isOpen} onHide={handleClose} centered contentClassName="checkout-modal-content">
        <style>{`.checkout-modal-content { border: none !important; border-radius: 20px !important; overflow: hidden !important; }`}</style>
        <div style={{ padding: '40px 32px', textAlign: 'center' }}>
          <div style={{ fontSize: '56px', marginBottom: '12px' }}>🎉</div>
          <h3 style={{ color: '#38a169', fontWeight: '700', marginBottom: '10px' }}>Matrícula realizada!</h3>
          <p style={{ color: '#4a5568', marginBottom: '24px', lineHeight: 1.6 }}>
            Sua conta foi criada com sucesso. Faça login para acessar a plataforma e acompanhar seu pagamento.
          </p>
          <button
            onClick={() => { handleClose(); history.push('/login'); }}
            style={{ ...btnPrimary, width: '100%', letterSpacing: '1px' }}
          >
            Fazer Login
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal show={isOpen} onHide={handleClose} centered size="lg" backdrop="static" scrollable contentClassName="checkout-modal-content">
      <style>{`
        .checkout-modal-content { border: none !important; border-radius: 20px !important; overflow: hidden !important; }
        @media (max-width: 600px) {
          .checkout-grid-2 { grid-template-columns: 1fr !important; }
          .checkout-grid-3 { grid-template-columns: 1fr 1fr !important; }
          .checkout-grid-4 { grid-template-columns: 1fr 1fr !important; }
          .checkout-grid-card { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>

      <div>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1e3a5f 0%, #1565c0 100%)',
          color: 'white',
          padding: '20px 24px 16px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <h4 style={{ margin: 0, fontWeight: '700', fontSize: '1.2rem' }}>Faça sua matrícula</h4>
              <span style={{ opacity: 0.85, fontSize: '13px' }}>
                Plano {plano} — {precoPlano.quant_parcelas}x R$ {(precoTotal / precoPlano.quant_parcelas).toFixed(2).replace('.', ',')}
              </span>
            </div>
            {!loading && (
              <button onClick={handleClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%', width: '32px', height: '32px', color: 'white', fontSize: '20px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>×</button>
            )}
          </div>

          {/* Indicador de etapas */}
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px', gap: '0' }}>
            {/* Etapa 1 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: '#fff', color: '#1565c0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '13px', flexShrink: 0 }}>
                {step > 1 ? '✓' : '1'}
              </div>
              <span style={{ fontSize: '12px', fontWeight: step === 1 ? '700' : '400', opacity: step === 1 ? 1 : 0.7, whiteSpace: 'nowrap' }}>Dados pessoais</span>
            </div>
            {/* Linha */}
            <div style={{ flex: 1, height: '2px', background: step >= 2 ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.35)', margin: '0 10px', minWidth: '20px' }} />
            {/* Etapa 2 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: step >= 2 ? '#fff' : 'rgba(255,255,255,0.25)', color: step >= 2 ? '#1565c0' : 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '13px', flexShrink: 0 }}>2</div>
              <span style={{ fontSize: '12px', fontWeight: step === 2 ? '700' : '400', opacity: step === 2 ? 1 : 0.6, whiteSpace: 'nowrap' }}>Pagamento</span>
            </div>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleFormSubmit} style={{ padding: '24px', background: '#fff', overflowY: 'auto', maxHeight: '68vh' }}>
          {error && (
            <div style={{ background: '#fff5f5', border: '1px solid #fed7d7', color: '#c53030', padding: '12px 16px', borderRadius: '10px', marginBottom: '20px', fontSize: '14px' }}>
              ⚠️ {error}
            </div>
          )}

          {/* ── Etapa 1: Dados do Aluno ── */}
          {step === 1 && (
            <>
              <p style={sectionTitleStyle}>Dados do Aluno</p>
              <div className="checkout-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <Field label="Nome completo">
                  <input style={inputStyle} placeholder="Seu nome completo" value={aluno.nome}
                    onChange={e => setAluno({ ...aluno, nome: e.target.value })} required />
                </Field>
                <Field label="CPF">
                  <input style={inputStyle} placeholder="000.000.000-00" value={aluno.cpf}
                    onChange={e => setAluno({ ...aluno, cpf: maskCPF(e.target.value) })} required />
                </Field>
              </div>
              <div className="checkout-grid-3" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '24px' }}>
                <Field label="Email">
                  <input style={inputStyle} type="email" placeholder="email@exemplo.com" value={aluno.email}
                    onChange={e => setAluno({ ...aluno, email: e.target.value })} required />
                </Field>
                <Field label="Senha">
                  <input style={inputStyle} type="password" placeholder="••••••••" value={aluno.senha}
                    onChange={e => setAluno({ ...aluno, senha: e.target.value })} required />
                </Field>
                <Field label="Telefone">
                  <input style={inputStyle} placeholder="(00) 00000-0000" value={aluno.telefone}
                    onChange={e => setAluno({ ...aluno, telefone: maskTelefone(e.target.value) })} required />
                </Field>
              </div>

              <button type="submit" style={{ ...btnPrimary, width: '100%' }}>
                Próximo →
              </button>
            </>
          )}

          {/* ── Etapa 2: Portador + Cartão ── */}
          {step === 2 && (
            <>
              <p style={sectionTitleStyle}>Dados do Portador do Cartão</p>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px', cursor: 'pointer', fontSize: '14px', color: '#4a5568' }}>
                <input type="checkbox" checked={mesmosDAados} onChange={e => setMesmosDados(e.target.checked)}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
                Mesmos dados do aluno
              </label>
              <div className="checkout-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <Field label="Nome do portador">
                  <input style={inputStyle} placeholder="Nome no cartão" value={portador.nome}
                    onChange={e => setPortador({ ...portador, nome: e.target.value })} required />
                </Field>
                <Field label="Email">
                  <input style={inputStyle} type="email" placeholder="email@exemplo.com" value={portador.email}
                    onChange={e => setPortador({ ...portador, email: e.target.value })} required />
                </Field>
              </div>
              <div className="checkout-grid-4" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '12px', marginBottom: '4px' }}>
                <Field label="CPF/CNPJ">
                  <input style={inputStyle} placeholder="Só números" value={portador.cpf_cnpj}
                    onChange={e => setPortador({ ...portador, cpf_cnpj: e.target.value.replace(/\D/g, '').slice(0, 14) })} required />
                </Field>
                <Field label="Telefone">
                  <input style={inputStyle} placeholder="(00) 00000-0000" value={portador.telefone}
                    onChange={e => setPortador({ ...portador, telefone: maskTelefone(e.target.value) })} required />
                </Field>
                <Field label="CEP">
                  <input style={inputStyle} placeholder="00000-000" value={portador.cep}
                    onChange={e => setPortador({ ...portador, cep: maskCEP(e.target.value) })} required />
                </Field>
                <Field label="Nº endereço">
                  <input style={inputStyle} placeholder="123" value={portador.numero}
                    onChange={e => setPortador({ ...portador, numero: e.target.value })} required />
                </Field>
              </div>

              <hr style={{ margin: '20px 0' }} />

              <p style={sectionTitleStyle}>Dados do Cartão de Crédito</p>
              <div className="checkout-grid-card" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <Field label="Número do cartão">
                  <input style={inputStyle} placeholder="0000 0000 0000 0000" value={cartao.numero}
                    onChange={e => setCartao({ ...cartao, numero: maskCartao(e.target.value) })} required />
                </Field>
                <Field label="Mês">
                  <input style={inputStyle} placeholder="MM" value={cartao.mes}
                    onChange={e => setCartao({ ...cartao, mes: e.target.value.replace(/\D/g, '').slice(0, 2) })} required />
                </Field>
                <Field label="Ano">
                  <input style={inputStyle} placeholder="AAAA" value={cartao.ano}
                    onChange={e => setCartao({ ...cartao, ano: e.target.value.replace(/\D/g, '').slice(0, 4) })} required />
                </Field>
                <Field label="CVC">
                  <input style={inputStyle} placeholder="123" value={cartao.ccv}
                    onChange={e => setCartao({ ...cartao, ccv: e.target.value.replace(/\D/g, '').slice(0, 4) })} required />
                </Field>
              </div>
              <div style={{ marginBottom: '24px' }}>
                <Field label="Parcelas">
                  <CustomSelect options={parcelasOptions} value={cartao.parcelas}
                    onChange={v => setCartao({ ...cartao, parcelas: v })} />
                </Field>
              </div>

              <div style={{ display: 'flex', gap: '12px' }}>
                <button type="button" onClick={() => { setStep(1); setError(''); }} style={btnSecondary} disabled={loading}>
                  ← Voltar
                </button>
                <button type="submit" disabled={loading} style={{ ...btnPrimary, opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}>
                  {loading ? 'Processando...' : 'MATRICULAR-SE AGORA'}
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </Modal>
  );
};

export default ModalCheckoutPlano;
